"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getOrderLineDescriptions = void 0;
const getLatestOrderLineVersion_1 = require("./getLatestOrderLineVersion");
const getOrderLineConfigDescriptions_1 = require("./getOrderLineConfigDescriptions");
const getOrderLineDescriptions = (item) => {
    if (!item.versions)
        return null;
    const latest_version = (0, getLatestOrderLineVersion_1.getLatestOrderLineVersion)(item.versions);
    if (!latest_version)
        return null;
    return (0, getOrderLineConfigDescriptions_1.getOrderLineConfigDescriptions)(latest_version.config, item.type);
};
exports.getOrderLineDescriptions = getOrderLineDescriptions;
